import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Resource } from '@mp-core/interfaces/resource';
import { ResourceType } from '@mp-core/enums/resource-type';
import { AlertService } from '@mp-core/services/alert.service';

@Component({
  selector: 'mp-resource-card',
  templateUrl: './resource-card.component.html',
  styleUrls: ['./resource-card.component.scss']
})
export class ResourceCardComponent {
  @Input() resource: Resource;
  @Input() showDelete: boolean = false;
  @Input() showCall: boolean = false;
  @Output() deleteEvent = new EventEmitter<string>();
  @Output() updateEvent = new EventEmitter<{ resourceId: string, quantity: number }>();

  resourceType = ResourceType;
  constructor(private alertService: AlertService) {
  }

  deleteResource(_id: string) {
    this.deleteEvent.emit(_id);
  }

  updateResource(resourceId: string, quantity: number) {
    this.updateEvent.emit({ resourceId, quantity });
  }

  copiedAlert() {
    this.alertService.success('Phone number copied successfully');
  }

  getResourceIconUrl(): string {
    switch (this.resource?.resourceName) {
      case ResourceType.MEDICINE:
        return './assets/images/medicine-icon.png';
      case ResourceType.OXYGEN:
        return './assets/images/oxygen-icon.png';
      case ResourceType.MEDICAL_KIT:
        return './assets/images/Kit.svg';
      case ResourceType.BLOOD:
        return './assets/images/Blood.svg'
    }
  }
}
